const DEFAULT_QUERY_OPERATORS = [
  "eq",
  "ne",
  "lt",
  "lte",
  "gt",
  "gte",
  "like",
  "notLike",
  "in",
  "notIn",
  "ASC",
  "DESC",
  "isNull",
];

const DEFAULT_LIST_QUERY_PARAMS = [
  "status",
  "listId",
  "imageListId",
  "workingListId",
  "imageWorkingListId",
];

export { DEFAULT_LIST_QUERY_PARAMS, DEFAULT_QUERY_OPERATORS };
